module.exports = __webpack_public_path__ + "img/tpd.77c435ed.svg";